import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const MechanicList = Loadable(
  lazy(() =>
    import("./MechanicList").then(({ MechanicList }) => ({
      default: MechanicList,
    }))
  )
);

const AddNewMechanic = Loadable(
  lazy(() =>
    import("./AddNewMechanic").then(({ AddNewMechanic }) => ({
      default: AddNewMechanic,
    }))
  )
);

export const mechanicListRoutes = [
  {
    path: "/mechanic-list",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <MechanicList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/create-new-mechanic",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <AddNewMechanic />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/create-new-mechanic/:id",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <AddNewMechanic />
      </AuthorizedRoute>
    ),
  },
];
